/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Reverse_RtlInputs */

const en_subtitle_export_reverse_rtl = /** @type {(inputs: Subtitle_Export_Reverse_RtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse RTL Start / End`)
};

const fr_subtitle_export_reverse_rtl = /** @type {(inputs: Subtitle_Export_Reverse_RtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inversion RTL Début / Fin`)
};

const de_subtitle_export_reverse_rtl = /** @type {(inputs: Subtitle_Export_Reverse_RtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umgekehrter RTL-Start/Ende`)
};

const it_subtitle_export_reverse_rtl = /** @type {(inputs: Subtitle_Export_Reverse_RtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizio/fine RTL inverso`)
};

const ru_subtitle_export_reverse_rtl = /** @type {(inputs: Subtitle_Export_Reverse_RtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обратное начало/конец RTL`)
};

const es_subtitle_export_reverse_rtl = /** @type {(inputs: Subtitle_Export_Reverse_RtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio/Fin RTL inverso`)
};

const zh_cn2_subtitle_export_reverse_rtl = /** @type {(inputs: Subtitle_Export_Reverse_RtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反向 RTL 开始/结束`)
};

const ja_subtitle_export_reverse_rtl = /** @type {(inputs: Subtitle_Export_Reverse_RtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`逆RTL開始/終了`)
};

const hi_subtitle_export_reverse_rtl = /** @type {(inputs: Subtitle_Export_Reverse_RtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिवर्स आरटीएल प्रारंभ / समाप्ति`)
};

const pt_pt2_subtitle_export_reverse_rtl = /** @type {(inputs: Subtitle_Export_Reverse_RtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início/Fim da inversão da RTL`)
};

/**
* | output |
* | --- |
* | "Reverse RTL Start / End" |
*
* @param {Subtitle_Export_Reverse_RtlInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_reverse_rtl = /** @type {((inputs?: Subtitle_Export_Reverse_RtlInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Reverse_RtlInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_reverse_rtl(inputs)
	if (locale === "de") return de_subtitle_export_reverse_rtl(inputs)
	if (locale === "it") return it_subtitle_export_reverse_rtl(inputs)
	if (locale === "ru") return ru_subtitle_export_reverse_rtl(inputs)
	if (locale === "es") return es_subtitle_export_reverse_rtl(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_reverse_rtl(inputs)
	if (locale === "ja") return ja_subtitle_export_reverse_rtl(inputs)
	if (locale === "hi") return hi_subtitle_export_reverse_rtl(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_reverse_rtl(inputs)
	return en_subtitle_export_reverse_rtl(inputs)
});